import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import { ProductIdType } from '../CurrentProductIdContext';
import {
  createCurrentIdStore,
  CurrentIdStore,
} from '../helpers/createCurrentIdStore';

const FIELD_NAME = 'productId';

export type CurrentProductIdContextStore = CurrentIdStore<
  typeof FIELD_NAME,
  ProductIdType
>;

export const useCurrentProductIdStore = createCurrentIdStore<
  typeof FIELD_NAME,
  ProductIdType
>({
  contextName: CONTEXT_NAMES.CurrentProductIdContext,
  fieldName: FIELD_NAME,
});
